import type { MemberPeriod, MemberStatus, MemberType } from "@features/admin/model/types";

/** 서버 상태는 3종이지만 화면에는 Active와 Expired 두 가지만 존재한다. */
export function isActiveStatus(status: MemberStatus): boolean {
  return status === "ACTIVE";
}

export function getStatusTranslationKey(status: MemberStatus): string {
  return isActiveStatus(status) ? "memberStatus_ACTIVE" : "memberStatus_EXPIRED";
}

/**
 * 기간 표기 규칙.
 * - Day Pass는 하루짜리라 단일 날짜만 표기한다.
 * - Active는 종료일을 알 수 없으므로 시작일과 물결표만 표기한다.
 * - Expired는 시작일과 종료일을 함께 표기한다.
 */
export function formatPeriod(period: MemberPeriod, status: MemberStatus, type: MemberType): string {
  const { start_date, end_date } = period;

  if (type === "DAY_PASS") {
    return start_date;
  }

  if (isActiveStatus(status) || !end_date) {
    return `${start_date} ~`;
  }

  return `${start_date} ~ ${end_date}`;
}
